export default __webpack_public_path__ + "media/images/business/coming-soon-1edeea942ab3d0b688673073fe924f0c.jpg";